
import styled from "styled-components"


// used in /watch and Footer
export const WatchSeparator = styled.div`
  width: 100%;
  padding: 0.1px 0px;
  background-color: ${p => p.theme.thirdCol};
`